import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'

import { HRRPayload } from './types'

export const HRR_DETAILS_KEY = 'hrrDetails'

export const hrrDetailsQueryOptions = (deps: Partial<HRRPayload>) =>
  queryOptions({
    queryKey: [HRR_DETAILS_KEY, deps],
    queryFn: () => Request.post(Request.urls.bank.hrrDetails, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
